<div [ngStyle]="containerStyle" mwlResizable [validateResize]="validate" [enableGhostResize]="false"
  [resizeSnapGrid]="{ top: 10 }"  (resizing)="onResizing($event)">
  <div class="resize-handle-top" mwlResizeHandle [resizeEdges]="{ top: true }">
    <ion-progress-bar *ngIf="loader" type="indeterminate" color="danger" style="z-index:3 !important;"></ion-progress-bar>
  </div>
  <div class="resize-handle-top" mwlResizeHandle [resizeEdges]="{ top: true }">
    <ion-progress-bar *ngIf="loader" type="indeterminate" color="danger" style="z-index:3 !important;"></ion-progress-bar>
  </div>
  <ion-header class="header">
    <ion-toolbar style="height: 25px; --background: #bae0fc;--min-height: 27px;--color: black; " >
      <ion-buttons slot="start" style="margin-bottom: 25px; ">
        <div style="display: flex;">
          <mat-icon class="icon terminal"
           style="padding: 0px 5px; width: 30px; font-size: 18px;vertical-align: baseline;">terminal</mat-icon>
          <ion-text style=" font-size: 12px;margin:0px 6px;vertical-align: super;">Console</ion-text>
        </div>
      </ion-buttons>
      <ion-title collapse="false">
        <ion-text></ion-text>
      </ion-title>
      <ion-buttons slot="end" style="margin-right: 10px; margin-bottom: 25px;">
        <div style="float:right;">
          <span style="cursor:pointer;" (click)="cancelconsole()"><ion-icon slot="start" name="close-circle-outline" style="font-size:16px !important;margin-top: 3px !important;margin-right: 4px !important;pointer-events: none !important;"></ion-icon></span>
        <button (click)="cancelconsole()" class="console-cancel-button">Cancel</button>
        </div>
        <div style="padding-bottom: 5px; padding-right: 8px;">
          <ion-text style="font-size: 12px;cursor: pointer;color: #2196f3;" (click)="clearLogs()">Clear</ion-text>
        </div>
        <div (click)="openLink()" style="padding-bottom: 5px; padding-right: 8px;">
          <ion-text style="font-size: 12px;cursor: pointer;color: #2196f3;">Close</ion-text>
        </div>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content *ngIf="consoleLogItems.length > 0">
    <div id="postman-preview">
      <mat-card class="preview-card">
        <mat-card-content class="preview-body">
          <div *ngFor="let item of consoleLogItems;let index = index">
            <ng-container>
              <div class="main-content" > 
                  <span class="res-header" (click)="showSubItem(index)">
                    <mat-icon style="height: 18px;" *ngIf="visibleIndex !== index" matSuffix>chevron_right</mat-icon>
                    <mat-icon style="height: 18px;" *ngIf="visibleIndex === index" matSuffix>expand_more</mat-icon>
                    <span *ngIf="isDataSource(detailedLogItems[index].operationName)">
                      Data Source - {{detailedLogItems[index].operationName}}
                    </span>
                    <span *ngIf="!isDataSource(detailedLogItems[index].operationName)">
                      Data Operation - {{detailedLogItems[index].operationName}}
                    </span>
                    <!-- <span *ngIf="items[index].operationName == 'API ( HTTPS, FTP, SFTP, SOAP/REST/ GraphQL)' ||  items[index].operationName == 'Database' || items[index].operationName == 'Websocket' || items[index].operationName == 'Bizintel360 Data Lake' || items[index].operationName == 'Email'">Data Source - {{items[index].operationName}}</span>
                    <span *ngIf="!(items[index].operationName == 'API ( HTTPS, FTP, SFTP, SOAP/REST/ GraphQL)' ||  items[index].operationName == 'Database' || items[index].operationName == 'Websocket' || items[index].operationName == 'Bizintel360 Data Lake' || items[index].operationName == 'Email')">Data Operation - {{items[index].operationName}}</span> -->
                    </span>
                  <div class="res-status">
                    <span *ngIf="detailedLogItems[index].status">{{detailedLogItems[index].status}}</span>
                    <span *ngIf="detailedLogItems[index].response_time">{{detailedLogItems[index].response_time}}</span>
                    <!-- <span>{{status}}</span>
                    <span>{{response_time}}</span> -->
                    <mat-icon [matTooltip]="copyStr" matTooltipPosition="above" style="cursor: pointer;" (click)="copyResponse(item.data)">
                      content_copy
                    </mat-icon>
                  </div>
              </div>
              <div *ngIf="visibleIndex === index" class="preview-subheader" style="margin-left:35px;margin-bottom: 10px;">
                <ng-container *ngFor="let key of getKeys(item.data)">
                  <json-editor class="console-bar" [options]="editorOptions" [data]="item.data[key]" (click)="changeErrorColor()"></json-editor>
                </ng-container>
              </div>
            </ng-container>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </ion-content>
  <!-- <div class="console-note">
    <div  class="note" [ngClass]="{ 'slide-in': consoleNoteMsg, 'slide-out': !consoleNoteMsg }">
      <mat-icon matTooltip="View More" matTooltipPosition="above" class="icon info">
        info
      </mat-icon>
      Note: In console only top 5 records are visible
    </div>
  </div>
   -->
  <div *ngIf="detailedLogItems.length == 0" style="text-align: center;margin-top: 100px;">
    <p style="font-size:14px">No logs available</p>
  </div>
</div>